<template>
  <div>
    <v-card class="ma-3" outlined>
      <v-card-text class="pa-2">
        <v-row no-gutters>

          <v-spacer/>

          <v-btn color="create white--text" @click="$emit('create')" depressed height="40">
            <v-icon left>mdi-plus</v-icon>
            Adaugă
          </v-btn>

        </v-row>
      </v-card-text>
    </v-card>
    <v-divider class="ma-3"/>
  </div>
</template>

<script>
  export default { }
</script>